import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { TermsComponent } from './terms.component';

@Injectable()
export class TermsService {
  constructor(private dialog: MatDialog) {}

  public display(needAccept: boolean): Observable<boolean> {
    let dialogRef: MatDialogRef<TermsComponent>;
    dialogRef = this.dialog.open(TermsComponent);
    dialogRef.componentInstance.needAccept = needAccept;
    return dialogRef.afterClosed();
  }
}
